export default {
  THANK_YOU: 'Thank you for your request!',
  GET_IN_TOUCH:
    'A member of our commercial team will get in touch with you soon.',
  OKAY: 'Okay',
}
